import React, { useEffect, useRef } from 'react';
import MainLayout from '../components/MainLayout';
import { Typography, Button, Row as AntRow, Col } from 'antd';
import { Link } from 'react-router-dom';
import routes from '../router/routes';
import AboutUs1Photo from '../assets/about-1.jpg'
import AboutUs2Photo from '../assets/about-2.jpg'
import AboutUs3Photo from '../assets/about-3.jpg'
import Header from '../assets/wasp-header.jpg'
import useViewportSize from '../hooks/useViewportSize';
import { Parallax } from 'react-parallax';
import cmkLogo from '../assets/CMK-logo.png'
import cebiosLogo from '../assets/cebios-logo.png'
import pairiDaizaLogo from '../assets/pairi-daiza-logo.png'
import dublinZooLogo from '../assets/dublin_zoo_logo.png'
import animalEmbassyLogo from '../assets/animal-embassy-logo.png'
import zooprahaLogo from '../assets/zoopraha-logo.png'
import copenhagenZooLogo from '../assets/Copenhagen-Zoo-logo.png'
import perthZooLogo from '../assets/perth-zoo-logo.png'
import straubingZooLogo from '../assets/straubing-zoo-logo.png'
import temaikenLogo from '../assets/temaiken-logo.png'
import zooDeLilleLogo from '../assets/zoo-de-lille-bicolore.png'
import africamSafariLogo from '../assets/africam-safari-logo.png'
import zoomarineLogo from '../assets/zoomarine-logo.png'
import limpopoLogo from '../assets/limpopo-uni-logo.jpeg'
import frog from '../assets/frog.jpg'
import maggot from '../assets/maggot.jpg'

const { Paragraph } = Typography;

const BREAKPOINT = 960;

const Row = React.forwardRef((props, ref) => (
  <AntRow ref={ref} gutter={24} {...props}/>
))

const AboutUsPage = () => {
  const publication = useRef();
  const aboutUs = useRef();
  const onMobile = useViewportSize() <= BREAKPOINT;
  const mtStyle = onMobile ? {marginTop: 24} : {};

  useEffect(() => {
    const interval = setInterval(() => {
      const pub = publication.current;
      const ab = aboutUs.current;
      if(pub && ab) {
        const h = pub.getBoundingClientRect().height;
        if(h) {
          ab.style.marginTop = `${h + 48}px`
        }
      }
    }, 1000)

    return () => {
      clearInterval(interval);
    }
  }, []);


  return (
    <MainLayout>
      <div className="about-page">

        <Parallax className="header" bgImage={Header} strength={200} bgImageStyle={{
          top:-32
        }}>
          <div className="parallax-content">
            <div className="title">
              WORLD ARCHIVES OF<br />SPECIES PERCEPTION
            </div>
            <div className="subtitle">
              Share your perception of nature&apos;s biodiversity!
            </div>
          </div>
        </Parallax>


        <div className="subheader">
          <div className="subheader-section-wrapper">
            <div>
              <img src={cmkLogo} alt={cmkLogo} id="cmk-logo" />
            </div>
            <Paragraph>
              WASP project is maintained by researchers at Centre for Environmental Sciences, UHasselt
            </Paragraph>
          </div>

          <div className="subheader-section-wrapper">
            <div className="title">
              Partners & Supporters
            </div>
          </div>

          <div className="subheader-section-wrapper images">
            <div>
              <img src={cebiosLogo} alt={'CEBIOD logo'} />
            </div>
            <div>
              <img src={pairiDaizaLogo} alt={'Pairi Daiza logo'} />
            </div>
            <div>
              <img src={dublinZooLogo} alt={'DublinZoo logo'} />
            </div>
            <div>
              <img src={zooprahaLogo} alt={'Zoopraha logo'} />
            </div>
            <div>
              <img src={animalEmbassyLogo} alt={'Animal Embassy logo'} />
            </div>
            <div>
              <img src={copenhagenZooLogo} alt={'Copenhagen Zoo logo'} />
            </div>
            <div>
              <img src={perthZooLogo} alt={'Perth Zoo logo'} />
            </div>
            <div>
              <img src={straubingZooLogo} alt={'Perth Zoo logo'} />
            </div>
            <div>
              <img src={temaikenLogo} alt={'Perth Zoo logo'} />
            </div>
            <div>
              <img src={africamSafariLogo} alt={'Africam Safari logo'} />
            </div>
            <div>
              <img src={zooDeLilleLogo} alt={'Zoo de Lille logo'} />
            </div>
            <div>
              <img src={zoomarineLogo} alt={'Zoomarine logo'} />
            </div>
            <div>
              <img src={limpopoLogo} alt={'University of Limpopo logo'} />
            </div>
          </div>
        </div>

        <div className="container">
          <div className="hr">
            <div></div>
          </div>
        </div>

        <div className="container">

          <div className="lalala">
            <Row className="how-it-works" style={{marginBottom: 64}}>
              <Col xs={24} lg={10}>
                <div>
                  <img src={frog} alt={frog} />
                </div>
              </Col>
              <Col xs={24} lg={14} style={mtStyle}>
                <div className="content">
                  <div className="title">
                    HOW IT WORKS
                  </div>
                  <ol>
                    <li>Observe and rate the species image on display</li>
                    <li>Stop and continue at your own pace</li>
                    <li>Share the survey and let others share their perception, too!</li>
                  </ol>
                  <Link to={routes.QUIZ}>
                    <Button className="btnn">Explore</Button>
                  </Link>
                </div>
              </Col>
            </Row>


            <Row className="contribute-science">
              <Col xs={24} lg={14}>
                <div className="content">
                  <div className="title">
                    CONTRIBUTE TO SCIENCE
                  </div>
                  <Paragraph>
                    Each species rated add to the global mapping of human perception for biodiversity. Together, we
                    can generate a global, open-access database for scientists to understand how human perception can help
                    reinforcing biodiversity conservation.
                  </Paragraph>
                </div>
              </Col>
              <Col xs={24} lg={10} style={mtStyle}>
                <div>
                  <img src={maggot} alt={maggot} />
                </div>
              </Col>
            </Row>


            <Row className="the-wasp">
              <Col xs={24} lg={14}>
                <div>
                  <img src={AboutUs1Photo} alt={AboutUs1Photo} />
                  <div className="photo-credits">
                    © Robin Gwen Agarwal, some rights reserved (CC BY-NC)
                  </div>
                </div>
              </Col>
              <Col xs={24} lg={10} style={mtStyle}>
                <div className="content">
                  <div className="title">
                    THE WASP PROJECT
                  </div>
                  <div>
                    <Paragraph className="paragraph">
                      Certain species are better-known than others, or attract more public attention. Why this is the
                      case,
                      remains an open question, not to mention which impact this has on decisions regarding the management
                      or
                      protection of these animals and plants. In any case, such impressions of certain species are not limited to the
                      public at large: the phenomenon of not all species being regarded as equal, is also seen among
                      professional scientists and policymakers.
                    </Paragraph>
                    <Paragraph className="paragraph">
                      In the “World Archives of Species Perception” (WASP) Project, we developed a citizen science
                      approach to
                      better understand how people look at animals and plants, and what determines their view and behavior
                      toward these species.
                    </Paragraph>
                    <Paragraph className="paragraph">
                      To date, the WASP Project is the largest and most comprehensive scientific attempt to bridge the gap
                      of
                      knowledge on public perception of biodiversity. We implement two separate surveys - WASP-A on
                      animals and
                      WASP-B on plants, each contains roughly 2,000 species representing about 58% and 76% of all the
                      species
                      families evaluated under the IUCN Red List.
                    </Paragraph>
                  </div>
                </div>
              </Col>
            </Row>

            <div className="publication">
              <div ref={publication}>
                <div className="container">
                  <div className="title">
                    For more information on our scientific methodology, please check out our publication:
                  </div>
                  <div>
                    <div>
                      1. Tuan Nguyen, Robert Malina, Ilias Mokas, Antonis Papakonstantinou, Orestes Polyzos, Maarten P M
                      Vanhove, WASP: the World Archives of Species
                    </div>
                    <div>
                      Perception, <i>Database</i>, Volume 2023, 2023, baad003, <a target="_blank" href="https://doi.org/10.1093/database/baad003" rel="noreferrer">https://doi.org/10.1093/database/baad003</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <Row className="about" ref={aboutUs} justify="start">
              <Col xs={24} lg={10}>
                <div className="content">
                  <div className="title">
                    ABOUT US
                  </div>
                  <div >
                    <Paragraph className="paragraph">
                      The WASP Project is developed and executed by researchers from Hasselt University in Belgium,
                      specifically
                      within the university’s Centre for Environmental Sciences (CMK). CMK harbors over 150 researchers. It
                      strives to be an international academic leader in holistic, multi-, and transdisciplinary research
                      regarding sustainability and the environment. Therefore, our institute is fertile ground for
                      collaborations like the one underlying the WASP Project, where zoologists and social scientists join
                      forces.
                    </Paragraph>
                    <Paragraph className="paragraph">
                      Ultimately, CMK wants to provide robust science-driven advice to public and private stakeholders at
                      various geographic levels. With this aim in mind, the WASP Projects intends to help bridging the gap
                      between biodiversity monitoring and biodiversity policy.
                    </Paragraph>
                  </div>
                </div>

              </Col>
              <Col xs={24} lg={14} style={mtStyle}>
                <div>
                  <img src={AboutUs2Photo} alt={AboutUs2Photo} />
                  <div className="photo-credits">
                    © Marco Mazza, some rights reserved (CC BY-NC)
                  </div>
                </div>
              </Col>
            </Row>



            <Row className="if-this">
              <Col xs={24} lg={10}>
                <div>
                  <img src={AboutUs3Photo} alt={AboutUs3Photo} />
                  <div className="photo-credits">
                    © Susan Elliott, some rights reserved (CC BY-NC)
                  </div>
                </div>
              </Col>
              <Col xs={24} lg={14} style={mtStyle}>
                <div className="content">
                  <div className="title">
                    IF THIS LEFT YOU WANTING MORE
                  </div>
                  <div>
                    <Paragraph className="paragraph">
                      <span>If you are curious about how the countless species we share a planet with are doing, you will find a treasure chest of information about threatened (and other) species in the International Union for Conservation of Nature’s Red List at </span>
                      <a href="https://www.iucnredlist.org/" target="_blank" rel="noreferrer">https://www.iucnredlist.org</a>.
                    </Paragraph>
                    <Paragraph className="paragraph">
              <span>If you like the images used in the WASP surveys, admire many more of them at <a
                href="https://www.inaturalist.org" target="_blank" rel="noreferrer">https://www.inaturalist.org</a>. And why not join iNaturalist yourself? You will be able to contribute your own observations in nature and the wildlife pictures you took, making them useful for scientific research. Also, you will be able to reach out to fellow naturalists and even receive help and feedback in case you like to try and identify what you encountered in nature.   </span>
                    </Paragraph>
                  </div>
                  <Link to={routes.QUIZ}>
                    <Button className="btnn">Take the survey</Button>
                  </Link>
                  <Button className="btnn"></Button>
                </div>
              </Col>
            </Row>


          </div>



          <div>


          </div>
        </div>
      </div>
    </MainLayout>
  )
};

export default AboutUsPage;
